import { defineNuxtPlugin, useRuntimeConfig, useRouter, nextTick } from "#imports";

import posthog from "posthog-js";
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public;

  if (config.POSTHOG_ENABLED !== 'true') return;

  // Initialize PostHog only when needed
  let posthogClient = null;

  const router = useRouter();
  router.afterEach((to) => {
    const allowedPaths = ["/trial", "/success/trial", "/success/getting-started"]; // Specify the pages where PostHog should be enabled

    if (allowedPaths.includes(to.path)) {
      if (!posthogClient) {
        // Initialize PostHog if not already initialized
        posthogClient = posthog.init(config.POSTHOG_KEY, {
          api_host: config.POSTHOG_HOST,
          capture_pageview: false, // we add manual pageview capturing below
          capture_pageleave: true, // automatically capture a pageleave event when the user leaves the site or closes the tab
          loaded: (posthog) => {
            if (import.meta.env.MODE === "development") posthog.debug();
          },
        });
      }

      // Capture pageview for the allowed pages
      nextTick(() => {
        posthog.capture("$pageview", {
          current_url: to.fullPath,
        });
      });
    } else if (posthogClient) {
      // Optionally, reset PostHog when navigating away from the allowed pages
      posthog.reset();
      posthogClient = null;
    }
  });

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});
